import { render, staticRenderFns } from "./FollowupsFilterButton.vue?vue&type=template&id=b867987e&scoped=true"
import script from "./FollowupsFilterButton.vue?vue&type=script&lang=js"
export * from "./FollowupsFilterButton.vue?vue&type=script&lang=js"
import style0 from "./FollowupsFilterButton.vue?vue&type=style&index=0&id=b867987e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b867987e",
  null
  
)

export default component.exports